module.exports = __webpack_public_path__ + "static/media/address-tip.c7b22257.svg";